export default __webpack_public_path__ + "static/media/roam-logo-twc.ff9df1b0.webp";